import ConventionClauseMiroir from '@/generated/controls/convention/ConventionClauseMiroir.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ConventionClauseMiroir
})
